import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import moment from "moment/moment"
export default function ViewCustomer() {
  const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [customer, setCustomer] = useState();
    const [orders, setOrders] = useState();
    const [pricingContracts, setPricingContracts] = useState([]);



    console.log("view customer page")

    // Load user
    useEffect(() => {
        console.log("loading customer...",params.id);

       
            axios
              .get(`https://${process.env.REACT_APP_IP}/api/customers/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
              })
              .then((res) => {
                console.log("Customer:", res.data);
                setCustomer(res.data);
                setLoading(false);
              })
              .catch((err) => {
                console.log(err);
                  setLoading(false);

                  if (err.response.status === 401) {
                      dispatch({ type: "LOGOUT" })
                      navigate("../")
                  }
              });
          
    }, [])

    useEffect(() => {
        if (customer === undefined) return;
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders?customerId=${customer.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Customer Orders:", res.data);
                setOrders(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });

        // Load any pricing contracts for this customer
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/${customer.id}/pricingcontracts`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Pricing Contracts:", res.data);
                setPricingContracts(res.data);

            })
            .catch((err) => {
                console.log(err);


                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });
    }, customer)

    

    const styles = {
        customer: {
            /*boxShadow: "0.05rem 0.05rem 1rem rgba(0, 0, 0, 0.3)",*/

            borderRadius: "0.25rem",
            overflow: "hidden",
            marginBottom: 10,
            paddingTop: 5,
            paddingBottom: 5,

            paddingLeft: 5,


            borderTop: "1em solid #A6A6A6",
            borderLeft: "1px solid #A6A6A6",
            borderRight: "1px solid #A6A6A6",
            borderBottom: "1px solid #A6A6A6",
        },





        statusText: {
            color: "#999"
        },

      

    }
    
    
    return (
        <div className="page">
            {loading && (<Spinner />)}
            {!loading && customer && (
                <div>

                    <div className="row">
                        <div className="col-12">

                            <h1>
                                {customer.name}
                                <Link to={`/Customers/Edit/${customer.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>
                            </h1>
                        </div>
                    </div>
                <div className="row">
                    <div className="col-5">
                  
                        
                       
                
                        <h3>Customer Details</h3>

                        {/* Account Code */}
                        <div className="row">
                            <div className="col-4">
                                Account Code
                            </div>
                            <div className="col-8">
                                {customer.code}
                            </div>
                        </div>

                        {/* Company Name */ }
                        <div className="row">
                            <div className="col-4">
                                Company Name
                            </div>
                            <div className="col-8">
                                {customer.name}
                            </div>
                        </div>

                        {/* Farm Name */}
                        <div className="row">
                            <div className="col-4">
                                Farm Name
                            </div>
                            <div className="col-8">
                                {customer.farm}
                            </div>
                        </div>

                        {/* Telephone */}
                        <div className="row" style={{marginTop: 10}}>
                            <div className="col-4">
                                Telephone
                            </div>
                            <div className="col-8">
                                {customer.telephone}
                            </div>
                        </div>
                        {/* Email */}
                        <div className="row">
                            <div className="col-4">
                                Email
                            </div>
                            <div className="col-8">
                                {customer.email}
                            </div>
                        </div>

                        <h3>Address</h3>

                            <div className="row">
                                <div className="col-4">
                                    <p>Billing Address</p>

                                    {/* Billing Address */}
                                        <div className="col-8 p-0" style={{ whiteSpace: "pre-line" }}>
                                            {customer.billingAddress}
                                        </div>

                                    {/* Billing Postcode */}
                                        <div className="col-8 p-0">
                                            {customer.billingPostcode}
                                        </div>
                                </div>

                                <div className="col-4">
                                    <p>Delivery Address</p>

                                    { customer.deliveryAddress ? (
                                        <>
                                        {/* Delivery Address */}
                                            <div className="col-8" style={{ whiteSpace: "pre-line" }}>
                                                {customer.deliveryAddress}
                                            </div>

                                        {/* Delivery Postcode */}
                                            <div className="col-8">
                                                {customer.deliveryPostcode}
                                            </div>
                                        </>
                                    ) : (<em>Same as billing address</em>) }
                                </div>
                            </div>

                        

                           
                        </div>
                        <div className="col-7">

                            {/* Other Details */}
                            <div className="row">
                                <div className="col-12">
                                    <h3>Other Details</h3>
                                </div>
                            </div>

                            {/* VAT Number */}
                            <div className="row">
                                <div className="col-4">
                                    VAT Number
                                </div>
                                <div className="col-8">
                                    {customer.vatNumber}
                                </div>
                            </div>

                            {/* Type Of Farm */}
                            <div className="row">
                                <div className="col-4">
                                    Type Of Farm
                                </div>
                                <div className="col-8">
                                    {customer.typeOfFarm.map((item, index) => (
                                        <span key={index}>
                                            {item}
                                            {index < customer.typeOfFarm.length - 1 && ", "}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            {/* Assigned Agent */}
                            <div className="row">
                                <div className="col-4">
                                    Assigned Agent
                                </div>
                                <div className="col-8">
                                    {customer.assignedAgent ? customer.assignedAgent.name : <em>No agent assigned</em>}
                                </div>
                            </div>

                            {/* Info Pack Received */}
                            <div className="row">
                                <div className="col-4">
                                    Info Pack Received
                                </div>
                                <div className="col-8">
                                    {customer.infoPackReceived ? "Yes" : "No"}
                                </div>
                            </div>

                            {/* Marketing Consent */}
                            <div className="row">
                                <div className="col-4">
                                    Marketing Consent?
                                </div>
                                <div className="col-8">
                                    {customer.marketingConsent ? "Yes" : "No"}
                                </div>
                            </div>

                            {/* Notes */}
                            <div className="row">
                                <div className="col-4">
                                    Notes
                                </div>
                                <div className="col-8" style={{ whiteSpace: "pre-line" }}>
                                    {customer.notes}
                                </div>
                            </div>

                            { /* Pricing Contracts */}
                            <div className="row">
                                <div className="col-12">
                                    <h3>Pricing Contracts

                                        <Link to={`/PricingContracts/Create/?customerId=${customer.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Create</Link>
                                    </h3>

                                </div>
                            </div>

                            <div style={{ fontSize: 14 }}>
                                <div className="row" style={{ borderBottom: "1px solid #ccc" }}>
                                    <div className="col-4">
                                        Customer
                                    </div>
                                    <div className="col-2">
                                        Cost Price
                                    </div>
                                    <div className="col-2">
                                        Sale Price
                                    </div>
                                    <div className="col-2">
                                        Haulage Rate
                                    </div>
                                </div>

                                {pricingContracts && pricingContracts.length > 0 && (
                                    pricingContracts.map((contract) => (
                                        <div style={{ borderBottom: "1px solid #ccc", marginTop: 10, paddingBottom: 10 }}>
                                            <div className="row">
                                                <div className="col-4">
                                                    {contract.product.name}<br />

                                                </div>
                                                <div className="col-2">
                                                    &pound;{contract.costPriceSummer.toFixed(2)} / &pound;{contract.costPriceWinter.toFixed(2)}
                                                </div>
                                                <div className="col-2">
                                                    &pound;{contract.salePriceSummer.toFixed(2)} / &pound;{contract.salePriceWinter.toFixed(2)}
                                                </div>
                                                <div className="col-2">
                                                    &pound;{contract.haulageRateSummer.toFixed(2)} / &pound;{contract.haulageRateWinter.toFixed(2)}
                                                </div>
                                                <div className="col-2">
                                                    <Link to={`/PricingContracts/Edit/${contract.id}`} className="btn-sm btn-other">Edit</Link>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-4">{moment(contract.startDate).format("DD/MM/YYYY")} - {contract.endDate ? moment(contract.endDate).format("DD/MM/YYYY") : "Ongoing"}</div>
                                                <div className="col-8">
                                                    {contract.tonnageAllowed > 0 && (
                                                        <span>
                                                            Allowed: {contract.tonnageAllowed.toFixed(2)} Remaining: {(contract.tonnageAllowed - contract.tonnageUsed).toFixed(2)}
                                                        </span>

                                                    )}

                                                </div>
                                            </div>



                                        </div>
                                    ))

                                )}
                                </div>

                        </div>

                    
                </div>


                    
                    <div className="row">
                        <div className="col-6">
                        <h3 style={{marginTop:20} }>Account Numbers</h3>

                        {customer.accountNumbers && customer.accountNumbers.map((item, index) => (
                            <div className="row">

                                {/* Invoice Account Number */}
                                <div className="col-3">
                                    {item.invoiceAccountNumber}
                                </div>

                                {/* Delivery Account Number */}
                                <div className="col-3">
                                    {item.deliveryAccountNumber}
                                </div>

                                {/* Supplier */}
                                <div className="col-6">
                                    {item.supplierName}
                                </div>
                            </div>
                        ))}
                        </div>

                        <h3 style={{ marginTop: 20 }}>Contacts</h3>



                        {customer && customer.contacts.length > 0 && (
                            <div className="row">
                                {customer.contacts.map((item, index) => (
                                    <div className="col-md-4" >
                                        <div style={{ ...styles.customer }}>
                                        <div className="col-12">
                                            <h6>{item.name} {item.role && "(" + item.role + ")"}</h6>
                                        </div>
                                        <div className="col-12" style={{ ...styles.statusText }}>
                                            Tel: {item.phone}
                                        </div>
                                        <div className="col-12" style={{ ...styles.statusText }}>
                                            Email: <a href={"mailto:" + item.email}>{item.email}</a>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        )}

                        {customer.contacts && customer.contacts.length == 0 && (
                            <em> No contacts found for this customer</em>
                        )}

                       
                    </div>

                        


                    <div className="row">
                        <div className="col-12">
                            <h3>Recent Orders</h3>

                            {orders && orders.length > 0 && (
                                <table style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 120 }}>Order No.</th>
                                            <th style={{ width: 150 }} className="d-none d-md-table-cell">Date</th>
                                            <th>Customer</th>
                                            <th>Agent</th>
                                            <th style={{ width: 100 }}>Status</th>
                                            <th style={{ width: 100 }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>Net Contribution</th>
                                            <th style={{ width: 80 }}>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map((order) => {
                                            return (
                                                <tr key={order.id} style={{ cursor: "pointer" }}>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.id}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{moment(order.dateOrdered).format('DD/MM/YYYY')}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.customer.name}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.agent.name}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.status}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{order.totalNetContribution.toFixed(2)}</td>

                                                    <td>
                                                        <Link to={`/Orders/View/${order.id}`} className="btn-sm btn-primary">View</Link>
                                                    </td>
                                                </tr>
                                            )
                                        })}


                                    </tbody>
                                </table>)}
                            {orders && orders.length == 0 && (
                                <em> No orders found for this customer</em>
                            )}
                        </div>
                    </div>


                </div>
            )}
        </div>
  )
}
